import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { useProductPageApiSwrFetchCartMetadata } from '../../../../api/swr/useProductPageApiSwrFetchCartMetadata'

/**
 * if private prescription,
 * load metadata,
 * if metadata has erx and private prescription, add to cart cta shall be disabled,
 * and some info message shall be shown
 */
export const useIsPrivatePrescriptionAndCartMetadataHasErx = (
  prescription: PrescriptionPrescriptionTypeEnum,
): boolean => {
  const isPrivatePrescription =
    prescription === PrescriptionPrescriptionTypeEnum.PrivatePrescription

  const metadata = useProductPageApiSwrFetchCartMetadata({
    disabled: !isPrivatePrescription,
  })

  return isPrivatePrescription && Boolean(metadata.data?.hasERxItems)
}
